import * as Scrivito from "scrivito"

import { HomepageAttributes, HomepageObjClass } from "./HomepageObjClass"

function HomePageComponent({
  page
}: Scrivito.PageComponentProps<HomepageAttributes>) {
  return <Scrivito.ContentTag content={page} attribute="body" />
}

Scrivito.provideComponent(HomepageObjClass, HomePageComponent)
